export default __webpack_public_path__ + "static/video-dot-grid-06aa984e85d957d44e8d9a042120dd67.svg";